<template>
    <main class="main" id="main">
        <div class="main_top_line">
            <div class="container">
                <div class="top_line_column">
                    <div class="m_tl_text">
                        <h1>Получи 100 рублей на телефон при любом заказе</h1>
                        <p>Введите адрес доставки <a  href="#">Пользовательское соглашение</a> </p>

                    </div>
                    <div class="m_tl_icons">
                        <a href="#"><div class="icon icon1"></div></a>
                        <a href="#"><div class="icon icon2"></div></a>
                        <a href="#"><div class="icon icon3"></div></a>
                        <a href="#"><div class="icon icon4"></div></a>
                        <!-- <div class="icon"></div>
                        <div class="icon"></div>
                        <div class="icon"></div>
                        <div class="icon"></div> -->
                    </div>
                    <div class="m_tl_text">
                        <h1>Получи 200 рублей за регистрацию на бонусный счёт</h1>
                    </div>
                    <button class="green_btn">Получить</button>

                </div>
            </div>
        </div>

        <section class="section_a">
            <div class="container ">
                <aside class="order_crytery">
                    <div class="order_crytery_title">
                        <h3>Критерии</h3>
                        <button type="button" class="choice_toggle" id="restaurant_toggle"></button>
                    </div>
                    <div class="order_crytery_inner" id="restaurant_crytery_inner">
                        <div class="meals">
                            <h3>Блюда</h3>
                            <div class="chack_group">
                                <label class="check_label" v-for="category in categories" :key="category.id">
                                    <input type="checkbox" name="choose" v-model="filter.categories[category.id]" :value="category.id">
                                    {{category.name}}
                                    <span> </span>
                                    <div class="dish_subcategory_one" v-if="filter.categories[category.id]">
                                        <div class="subcategoryOne_check_box" v-if="additives_temp[additive.id]" v-for="additive in category.additives" :key="additive.id">
                                            <label class="check_label">
                                                <input type="checkbox" v-model="filter.additives[additive.id]" :value="additive.id" name="choose">
                                                {{additive.name}}
                                                <span> </span>
                                            </label>
                                            <div class="dish_subcategory_two" v-if="filter.additives[additive.id]">
                                                <label class="check_label" v-if="ingredients_temp[ingredient.id]" v-for="ingredient in additive.ingredients" :key="ingredient.id">
                                                    <input type="checkbox" v-model="filter.ingredients[ingredient.id]" :value="ingredient.id" name="choose">
                                                    {{ingredient.name}}
                                                    <span> </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>

                        </div>
                        <div class="min_amount">
                            <h3>Минимальная сумма заказа</h3>
                            <div class="range_value">
                                <p id="display_range_value_2">{{price}}</p>
                            </div>
                            <div class="change_range">
                                <input type="range" id="min_amount_range_2" :min="priceMin" v-model="price" :max="priceMax" name="min_amount_range">
                            </div>

                        </div>
                    </div>
                </aside>

                <!-- adding sidebar from separate html file -->
                <!-- <link rel="import" href="order_crytery.html">
                <script>
                    var dist = document.querySelector('.section_a .container')
                    var doc = document.querySelectorAll('link[rel="import"]');
                    for(i of doc) {
                    var cool = i.import;
                    var go = cool.querySelector('.order_crytery');
                    dist.appendChild(go.cloneNode(true));
                    }
                </script> -->
                <!-- adding sidebar from separate html file -->
                <div class="rest_item_wrapper">
                    <h3 class="rest_item_title">
                        О ресторане
                    </h3>

                    <rest-block :restaurant.sync="restaurant"  :auth.sync="auth" :city.sync="city"></rest-block>

                    <div class="restrunt_menu_wrapper">
                        <div :class="basket.amount && parseInt(basket.amount) !==0?'menu_container':'menu_container empty'">
                            <div class="restrunt_menu">
                                <div class="menu_header">
                                    <router-link class="menu_link" tag="div" :to="'/restaurant/' + restaurant.id">
                                        <span>Меню</span>
                                    </router-link>
                                    <router-link class="menu_link" tag="div" :to="'/restaurant/' + restaurant.id + '/reviews'">
                                        <span>Отзывы</span>
                                    </router-link>
                                </div>
                            </div>
                            <div class="sorting_block">

                                <div class="amount_of_dish">

                                </div>

                                <div class="buttons_wrapper">

                                    <button @click="view = 'square'" type="button" :class="view==='square'?'menu_item_btn list_active':'menu_item_btn'">
                                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/square.svg" alt="">
                                        Плиткой
                                    </button>

                                    <button @click="view = 'list'" type="button" :class="view==='list'?'menu_item_btn list_active':'menu_item_btn'">
                                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/list.svg" alt="">
                                        Списком
                                    </button>

                                </div>
                            </div>

                            <div v-if="view === 'list'" class="list_view">
                                <div class="dishes_list">
                                    <div :class="index%2?'dish bg_color':'dish'" v-for="(product, index) in products" v-if="product.show && (product.category !== 15 && Object.values(product.additives).join(',') !== '67')" :key="product.id">
                                        <div class="dish_name">
                                            <h3>{{product.name}}</h3>
                                            <h4>{{product.restaurant_name}}</h4>
                                            <div class="item">
                                              <div class="title">
                                                      <h4>{{product.name}}</h4>
                                                      <!-- a href="#" v-if="restaurant.stocks[product.id]" class="stock">Акция</a-->
                                              </div>
                                              <div class="main_description">
                                                  <img :src="product.photo" :alt="product.name" style="width: 100%;">
                                                  <div class="link_row" style="display: none">
                                                      <a href="#" class="rest_name">Планета суши</a>
                                                      <p class="delivery_time">45 мин</p>
                                                  </div>
                                              </div>
                                              <div class="text_row">
                                                  <p>{{product.desc}}</p>
                                              </div>
                                              <div class="prise_row">
                                                  <p><strong>{{product.price}}</strong> / {{product.weight}} {{product.weight_type}}</p>
                                                  <button class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                                              </div>
                                            </div>
                                        </div>
                                        <div class="dish_middle" >
                                            <!--div class="sale_box">
                                              <span class="sale">Акция</span>
                                              <div v-if="restaurant.stocks[product.id]" class="sales_inner">
                                                  <div class="sales_header">
                                                      <div class="sales_time">
                                                              <countdown tag="h2" :time="new Date((restaurant.stocks[product.id].to).split('.')[2],(restaurant.stocks[product.id].to).split('.')[1]-1,(restaurant.stocks[product.id].to).split('.')[0]) - new Date()">
                                                                  <template slot-scope="props" v-if="props.days > 0">{{ props.days }} дней</template>
                                                                  <template slot-scope="props" v-else>{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</template>
                                                              </countdown>
                                                          <span>До конца акции</span>
                                                      </div>
                                                  </div>
                                                  <div class="sales_image">
                                                      <img :src="restaurant.stocks[product.id].photo" alt="">
                                                      <span>{{restaurant.stocks[product.id].text}}</span>
                                                  </div>
                                                  <div class="sales_bottom">
                                                      <p>{{restaurant.stocks[product.id].description}}</p>
                                                      <button type="button" class="menu_item_btn" @click="putInBasket(product.id)">Получить</button>
                                                  </div>
                                              </div>
                                            </div-->
                                            <span class="price">{{product.price}} </span>
                                            <span class="weight">/{{product.weight}} {{product.weight_type}}</span>
                                        </div>
                                        <button type="button" class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="view === 'square'" class="square_view">
                                <div class="items_group">
                                    <div class="sales_inner" v-if="restaurant.open !== 'close'&&restaurant.city_id === city.id" v-for="(stock, index) in restaurant.stocks" :key="index">
                                        <div class="sales_header">
                                            <div class="sales_time">
                                                <countdown tag="h2" :time="new Date((stock.to).split('.')[2],(stock.to).split('.')[1]-1,(stock.to).split('.')[0]) - new Date()">
                                                    <template slot-scope="props" v-if="props.days > 0">{{ props.days }} дней</template>
                                                    <template slot-scope="props" v-else>{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</template>
                                                </countdown>
                                                <span>до конца акции</span>
                                            </div>
                                        </div>
                                        <div class="sales_image">
                                            <img :src="stock.photo" alt="">
                                            <span>{{stock.text}}</span>
                                        </div>
                                        <div class="sales_bottom">
                                            <p>{{stock.description}}</p>
                                            <button type="button" class="menu_item_btn" @click="putInBasket(stock.product_id)">Получить</button>
                                        </div>
                                    </div>
                                    <slot v-for="product in products" v-if="product.show && (product.category !== 15 && Object.values(product.additives).join(',') !== '67')">
                                        <item-block  :key="product.id" :product.sync="product" :basket.sync="basket"></item-block>
                                    </slot>
                                </div>
                            </div>
                            <!-------Show more(button)----------->

                        </div>
                        <cart-sidebar :basket.sync="basket" :auth.sync="auth"></cart-sidebar>
                    </div>
                </div>

            </div>
        </section>
        <section class="section_b">
            <div class="container">
                <div class="title">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/big_van_24.svg" alt="big_van_24">
                    <h1>Круглосуточная доставка еды</h1>
                </div>
                <p>
                    Служба доставки еды "ХОЧУ-ПОЕСТЬ.РФ" в городе {{city.name}} - это свыше 1000 блюд и напитков, которые привезут вам домой или в офис без наценок и дополнительной комиссии от лучших ресторанов Вашего города. Есть из чего выбрать! Вы видите то, что Вы заказываете, и точно знаете стоимость, которую нужно заплатить.
                </p>
            </div>
        </section>
    </main>

</template>

<script>
import Vue from 'vue'
import axios from '@/router/http'
import cartSidebar from '@/components/cartSidebar'
import restBlock from '@/components/restaurant'
import itemBlock from '@/components/item'
import countdown from '@chenfengyuan/vue-countdown'
import $ from 'jquery'
export default {
  name: 'restaurant',
  props: ['city', 'auth', 'basket', 'geo'],
  components: { cartSidebar, restBlock, itemBlock, countdown },
  data () {
    return {
      restaurant: {id: null, name: null, categories: []},
      products: {},
      categories: [],
      showProducts: [],
      showAdv: [],
      priceMin: null,
      priceMax: null,
      price: 0,
      filterWrap: 0,
      itemLimit: 30,
      title: 'ресторан',
      loading: 0,
      view: 'square',
      filter: {
        categories: {},
        additives: {},
        ingredients: {}
      },
      additives_temp: {},
      ingredients_temp: {},
      setInitReshow: 0
    }
  },
  metaInfo () {
    return {
      title: ' - ' + this.restaurant.name,
      meta: [
        { vmid: 'description', name: 'description', content: 'Ресторан ' + this.restaurant.name + ' - ' + this.restaurant.desc }
      ]
    }
  },
  created () {
    this.restaurant.id = null
    if (this.auth.uid) this.initPage()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initPage()
        }
      }, 100)
    }
  },
  mounted () {
    $('.select').select2()
    let $this = this
    $('#restaurant_toggle').on('click', function () {
      $('#restaurant_crytery_inner').toggleClass('active')
      $('.choice_toggle').toggleClass('active')
    })

    $('#min_amount_range').on('input', function () {
      $this.price = $(this).val()
      $this.reshow()
    })
    $('#min_amount_range_2').on('input', function () {
      $this.price = $(this).val()
      $this.reshow()
    })

    this.checkPosition()
    $(document).scroll(() => {
      this.checkPosition()
    })
    $(window).resize(() => {
      this.checkPosition()
    })
  },
  watch: {
    $route (to, from) {
      this.initPage()
    },
    'view' (val, oldVal) {
      if (val && val !== oldVal) {
        this.itemLimit = 30
        this.reshow()
      }
    },
    'restaurant.name' (val) {
      this.title = 'ресторан ' + this.restaurant.name
    },
    'price' (val) {
      this.reshow()
    },
    filter: {
      handler (newVal, oldVal) {
        this.reshow()
      },
      deep: true
    },
    'restaurant.id' (val, old) {
      if (val !== null && val !== old && this.restaurant.open !== 'close' && (this.restaurant.city_id === this.city.id || !this.city.id || this.auth.user_agent === 'bot')) {
        axios.get('https://lk.when-hungry.com/mobile/products-get?type=restaurant&id=' + this.$route.params.id + '&uid=' + this.auth.uid).then(response => {
          this.products = response.data.products
          this.priceMax = response.data.max
          this.priceMin = response.data.min
          this.price = response.data.max
          this.additives_temp = response.data.additives_temp
          this.ingredients_temp = response.data.ingredients_temp
          this.reshow()
        })
      }
    }
  },
  methods: {
    initPage () {
      var id = this.$route.params.id
      this.loading = 1
      axios.get('https://lk.when-hungry.com/mobile/restaurant-get?id=' + id + '&uid=' + this.auth.uid).then(response => {
        this.restaurant = response.data.restaurants
        this.categories = response.data.kitchens
        this.priceMax = response.data.max
        this.priceMin = response.data.min
        this.loading = 0
        this.restaurant.show = 1
      })
    },
    checkPosition () {
      let element
      if ($('.item').length !== 0) element = $('.item').eq(-3)
      if ($('.dish').length !== 0) element = $('.dish').eq(-20)
      if (element !== undefined && element.length !== 0) {
        var divPosition = element.offset()
        var divTop = divPosition.top
        var divLeft = divPosition.left
        var divWidth = element.width()
        var divHeight = element.height()
        var topScroll = $(document).scrollTop()
        var leftScroll = $(document).scrollLeft()
        var screenWidth = $(window).width()
        var screenHeight = $(window).height()
        var seeX1 = leftScroll
        var seeX2 = screenWidth + leftScroll
        var seeY1 = topScroll
        var seeY2 = screenHeight + topScroll
        var divX1 = divLeft
        var divX2 = divLeft + divHeight
        var divY1 = divTop
        var divY2 = divTop + divWidth
        if (divX1 >= seeX1 && divX2 <= seeX2 && divY1 >= seeY1 && divY2 <= seeY2) {
          this.itemLimit += 10
          this.reshow()
        }
      }
    },
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    reshow () {
      if (!this.setInitReshow) {
        this.setInitReshow = 1
        this.showProducts = []
        this.showAdv = []
        let categories = this.filter.categories
        let additives = this.filter.additives
        let ingredients = this.filter.ingredients
        $.each(categories, (k, v) => {
          if (v === false) {
            Vue.delete(categories, k)
            $.each(this.categories[k].additives, (kk, vv) => {
              Vue.delete(additives, kk)
              $.each(this.categories[k].additives[kk].ingredients, (kkk, vvv) => {
                Vue.delete(ingredients, kkk)
              })
            })
          }
        })
        $.each(additives, (k, v) => {
          if (v === false) {
            Vue.delete(additives, k)
            $.each(categories, (ks, vs) => {
              $.each(this.categories[ks].additives[k].ingredients, (kk, vv) => {
                Vue.delete(ingredients, kk)
              })
            })
          }
        })
        $.each(ingredients, (k, v) => {
          if (v === false) Vue.delete(ingredients, k)
        })
        let count = 0
        for (let productId in this.products) {
          let sc = 0
          let sa = 0
          let si = 0
          let saa = 0
          if (Object.keys(categories).length) {
            $.each(categories, (k, v) => {
              if ($.inArray(parseInt(k), this.products[productId].category_id) !== -1) sc = 1
            })
          } else sc = 1

          if (Object.keys(additives).length) {
            $.each(additives, (k, v) => {
              if ($.inArray(k, Object.keys(this.products[productId].additives)) !== -1) sa = 1
            })
          } else sa = 1

          if (Object.keys(ingredients).length) {
            $.each(ingredients, (k, v) => {
              if ($.inArray(k, Object.keys(this.products[productId].ingredients)) !== -1) si = 1
            })
          } else si = 1
          if (parseInt(this.products[productId].price) <= this.price) saa = 1
          if (sc === 1 && sa === 1 && si === 1 && saa === 1 && count <= this.itemLimit) {
            this.products[productId].show = 1
            this.showProducts.push(this.products[productId].id)
            count++
          } else this.products[productId].show = 0
        }
        this.setInitReshow = 0
      }
    },
    putInBasket (id) {
      if (this.geo.address && this.geo.lat2 && this.geo.lng2) {
        var formData = new FormData()
        formData.append('id', id)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-in-basket',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.$root.basketUpdate = 1
        })
      } else this.$root.modals = 'selectCity'
    },
    plusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/plus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    },
    minusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/minus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/restaurant.vue